import { Injector, model } from "@angular/core";
import { Art57NodeList } from "../../Art57Node/Art57NodeList";
import { ListView } from "../../../Data/ListView";
import { TreeNodeSubstanceTranslation } from "../Entity/TreeNodeSubstanceTranslation";
import { BaseNode } from "../../BaseNode";
import { environment } from "../../../../../../environments/environment";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";

export class TreeNodeMedicinalProductsSubstanceTranslation extends Art57NodeList{
    items: any;
    cloningNode: boolean = false;
    constructor(injector: Injector, parent:any,cloningNode: boolean, items: any[]|undefined) {
        super(injector, new ListView(), `Substance Translations (${items?items.length:'-'})`);
        this.parent = parent;
        this.cloningNode = cloningNode;
        this.labelNodeName = 'Substance Translations'
        this.items = items;

        if (this.cloningNode) {
            return;
        }
        for (const item of items || []) {
            this.children?.push(new TreeNodeSubstanceTranslation(injector, item,this));
        }
    }

    override getHeaders(): string[] {
        return ['Language Code', 'Translation'];
    }

   override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeMedicinalProductsSubstanceTranslation = new TreeNodeMedicinalProductsSubstanceTranslation(this.ioc!,newParent, true, this.items);        
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
 
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.cloningNode = false;
      return clonedNode;
    }   
}